"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {
  '/collections': {
    title: 'Collections',
    view: 'Collections',
    "public": true,
    locales: {
      az: '/az/collections',
      en: '/en/collections',
      ru: '/ru/collections'
    }
  },
  '/az/collections': {
    ref: '/collections',
    lang: 'az',
    title: 'Kolleksiyalar'
  },
  '/en/collections': {
    ref: '/collections',
    lang: 'en',
    title: 'Collections'
  },
  '/ru/collections': {
    ref: '/collections',
    lang: 'ru',
    title: 'Коллекции'
  }
};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyb3V0ZXMiLCJ0aXRsZSIsInZpZXciLCJsb2NhbGVzIiwiYXoiLCJlbiIsInJ1IiwicmVmIiwibGFuZyIsIl9kZWZhdWx0IiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL2xpYnJhcnkvc3JjL2NsaWVudC9tb2R1bGVzL0Vjb21tZXJjZS9Db2xsZWN0aW9uL0NvbGxlY3Rpb25Sb3V0ZXMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3Qgcm91dGVzID0ge1xyXG4gICAgJy9jb2xsZWN0aW9ucyc6IHtcclxuICAgICAgICB0aXRsZTogJ0NvbGxlY3Rpb25zJyxcclxuICAgICAgICB2aWV3OiAnQ29sbGVjdGlvbnMnLFxyXG4gICAgICAgIHB1YmxpYzogdHJ1ZSxcclxuICAgICAgICBsb2NhbGVzOiB7XHJcbiAgICAgICAgICAgIGF6OiAnL2F6L2NvbGxlY3Rpb25zJyxcclxuICAgICAgICAgICAgZW46ICcvZW4vY29sbGVjdGlvbnMnLFxyXG4gICAgICAgICAgICBydTogJy9ydS9jb2xsZWN0aW9ucycsXHJcbiAgICAgICAgfVxyXG4gICAgfSxcclxuICAgICcvYXovY29sbGVjdGlvbnMnOiB7cmVmOiAnL2NvbGxlY3Rpb25zJywgbGFuZzogJ2F6JywgdGl0bGU6ICdLb2xsZWtzaXlhbGFyJ30sXHJcbiAgICAnL2VuL2NvbGxlY3Rpb25zJzoge3JlZjogJy9jb2xsZWN0aW9ucycsIGxhbmc6ICdlbicsIHRpdGxlOiAnQ29sbGVjdGlvbnMnfSxcclxuICAgICcvcnUvY29sbGVjdGlvbnMnOiB7cmVmOiAnL2NvbGxlY3Rpb25zJywgbGFuZzogJ3J1JywgdGl0bGU6ICfQmtC+0LvQu9C10LrRhtC40LgnfSxcclxufVxyXG5cclxuZXhwb3J0IGRlZmF1bHQgcm91dGVzO1xyXG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLElBQU1BLE1BQU0sR0FBRztFQUNYLGNBQWMsRUFBRTtJQUNaQyxLQUFLLEVBQUUsYUFBYTtJQUNwQkMsSUFBSSxFQUFFLGFBQWE7SUFDbkIsVUFBUSxJQUFJO0lBQ1pDLE9BQU8sRUFBRTtNQUNMQyxFQUFFLEVBQUUsaUJBQWlCO01BQ3JCQyxFQUFFLEVBQUUsaUJBQWlCO01BQ3JCQyxFQUFFLEVBQUU7SUFDUjtFQUNKLENBQUM7RUFDRCxpQkFBaUIsRUFBRTtJQUFDQyxHQUFHLEVBQUUsY0FBYztJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBZSxDQUFDO0VBQzVFLGlCQUFpQixFQUFFO0lBQUNNLEdBQUcsRUFBRSxjQUFjO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFhLENBQUM7RUFDMUUsaUJBQWlCLEVBQUU7SUFBQ00sR0FBRyxFQUFFLGNBQWM7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQVc7QUFDM0UsQ0FBQztBQUFBLElBQUFRLFFBQUEsR0FBQUMsT0FBQSxjQUVjVixNQUFNIn0=